module.exports = __webpack_public_path__ + "img/avatar1.226300a3.png";